var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWikiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6317 1.36816C22.1227 5.85919 22.1227 13.1406 17.6317 17.6316C13.3308 21.9325 6.47094 22.1146 1.95335 18.178C1.75634 18.0064 1.65783 17.9205 1.61336 17.8032C1.57595 17.7044 1.57176 17.5824 1.60232 17.4813C1.63863 17.3612 1.73705 17.2628 1.93388 17.0659L4.14913 14.8507M16.9999 9.49989C16.9999 13.642 13.6421 16.9999 9.49992 16.9999C5.35779 16.9999 1.99992 13.642 1.99992 9.49989C1.99992 5.35776 5.35779 1.99989 9.49992 1.99989C13.6421 1.99989 16.9999 5.35776 16.9999 9.49989Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiIcon);
export default __webpack_public_path__ + "static/media/WikiIcon.cd1ea08e80c2fc974fc2212a219376d1.svg";
export { ForwardRef as ReactComponent };